import Div from "theme/layouts/Div";
import PropTypes from "prop-types";
import React from "react";
import ScrollToButton from "theme/components/buttons/functionalButtons/ScrollToButton";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import { above } from "core-web/utils/mediaqueries";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { wysiwygProp } from "core-web/utils/proptypes/modules/textProps";

const ShortParagraph = styled("div")`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${above.tabletLg} {
        -webkit-line-clamp: 2;
    }
`;

const TextHero = ({ heading = [], paragraph = [] }) => {
    const { t } = useTranslation();
    const pageTitle = useSelector(({ page }) => page?.data?.title);

    //if length check is changed, it should be updated in the Category/Default as well
    const isDescriptionTooLong = paragraph?.length > 1 || paragraph[0]?.length > 300;

    return (
        <Div pt={["48px", null, null, null, "64px"]} pb={["24px", null, null, null, "80px"]}>
            <TextStyles
                as="h1"
                textStyles={["Myriad Pro/40-120-semibold", null, null, null, "Myriad Pro/64-110-semibold"]}
                maxWidth="875px"
            >
                {heading?.[0] || pageTitle}
            </TextStyles>

            {!!paragraph?.length && (
                <ShortParagraph m="8px 0 16px">
                    <Wysiwyg
                        data={paragraph}
                        textComponent={(props) => (
                            <TextStyles
                                textStyles={["Myriad Pro/18-140", null, null, null, "Myriad Pro/20-140"]}
                                display="block"
                                maxWidth="515px"
                                {...props}
                            />
                        )}
                    />
                </ShortParagraph>
            )}

            {/* TODO: Make ScrollToButton optional if TextHero will be used somewhere else than just the Category page */}
            {isDescriptionTooLong && (
                <ScrollToButton
                    ariaLabel={t("read_more")}
                    className="long-description"
                    textColor={colors.black_70}
                    mt="12px"
                >
                    <TextStyles textStyles="Myriad Pro/16-100">{t("general.read_more")}</TextStyles>
                </ScrollToButton>
            )}
        </Div>
    );
};

export default TextHero;
